// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/common/day_of_week.proto
/* eslint-disable */
export const protobufPackage = "squareup.connect.v2.common";
/**
 * --
 * @desc
 * Indicates the specific day  of the week.
 * --
 */
export var DayOfWeek;
(function (DayOfWeek) {
    /** SUN - @desc Sunday */
    DayOfWeek[DayOfWeek["SUN"] = 0] = "SUN";
    /** MON - @desc Monday */
    DayOfWeek[DayOfWeek["MON"] = 1] = "MON";
    /** TUE - @desc Tuesday */
    DayOfWeek[DayOfWeek["TUE"] = 2] = "TUE";
    /** WED - @desc Wednesday */
    DayOfWeek[DayOfWeek["WED"] = 3] = "WED";
    /** THU - @desc Thursday */
    DayOfWeek[DayOfWeek["THU"] = 4] = "THU";
    /** FRI - @desc Friday */
    DayOfWeek[DayOfWeek["FRI"] = 5] = "FRI";
    /** SAT - @desc Saturday */
    DayOfWeek[DayOfWeek["SAT"] = 6] = "SAT";
    DayOfWeek[DayOfWeek["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DayOfWeek || (DayOfWeek = {}));
